import { DestroySalaryRangeDocument, DestroySalaryRangeMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDestroySalaryRange = () => {
  const [mutate, { loading }] = useMutation(DestroySalaryRangeDocument, {
    extractorFn: (data: DestroySalaryRangeMutation) =>
      data.jobCatalogMutations.destroyJobcatalogSalaryRange,
  })

  const destroySalaryRange = (id: number) => {
    return mutate({ variables: { id } })
  }

  return { destroySalaryRange, isMutating: loading }
}

export default useDestroySalaryRange
